<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22.256"
    height="23.108"
    viewBox="0 0 22.256 23.108"
  >
    <g transform="translate(-9.432 0)">
      <g transform="translate(9.432 0)">
        <g transform="translate(0 0)">
          <path
            d="M90.3,313.483C90.278,313.483,90.316,313.485,90.3,313.483Z"
            transform="translate(-86.642 -299.334)"
            fill="#777"
          />
          <path
            d="M31.237,20.4a21.168,21.168,0,0,1-4.606-.508,5.382,5.382,0,0,0,.315-1.77,5.128,5.128,0,0,0-1.465-3.682,5.211,5.211,0,0,0-2.3-1.359l-.023-.006a14.976,14.976,0,0,1-5.884-3.189.451.451,0,1,0-.6.679,16.127,16.127,0,0,0,1.972,1.48,5.239,5.239,0,0,1,.583,2.564.451.451,0,0,0,.438.465h.014a.451.451,0,0,0,.451-.438,6.152,6.152,0,0,0-.234-1.873,15.884,15.884,0,0,0,2.324.971A5.225,5.225,0,0,1,23,16.226a.451.451,0,0,0,.45.43h.022a.451.451,0,0,0,.429-.473,6.112,6.112,0,0,0-.464-2.056,4.28,4.28,0,0,1,2.315,5.552A21.258,21.258,0,0,1,13.816,11.3a.451.451,0,1,0-.741.516,22.3,22.3,0,0,0,7.758,6.9A21.958,21.958,0,0,0,25.327,20.5a4.406,4.406,0,0,1-.532.661,3.845,3.845,0,0,1-3.612.916A14.735,14.735,0,0,1,17.04,20.2a6.089,6.089,0,0,0,1.236-.255A.451.451,0,1,0,18,19.087a5.148,5.148,0,0,1-2.212.2,14.831,14.831,0,0,1-1.121-1.012,14.684,14.684,0,0,1-3.068-4.5,6.3,6.3,0,0,0,1.485.37.479.479,0,0,0,.476-.394.451.451,0,0,0-.392-.5,5.148,5.148,0,0,1-2.047-.713A14.874,14.874,0,0,1,11.564,1.9a16.072,16.072,0,0,0,2.386,5.579A.451.451,0,0,0,14.7,6.97,15.172,15.172,0,0,1,12.221.4a.451.451,0,0,0-.843-.161,15.723,15.723,0,0,0-1.8,9.681,15.714,15.714,0,0,0,11.37,13.033,4.517,4.517,0,0,0,1.2.161,4.782,4.782,0,0,0,3.27-1.29l.015-.014.012-.013a5.252,5.252,0,0,0,.8-1.058,22.2,22.2,0,0,0,4.995.571.451.451,0,0,0,0-.9Z"
            transform="translate(-9.432 0)"
            fill="#777"
          />
        </g>
        <path
          d="M135.865,186.464a.452.452,0,1,0-.319-.132A.455.455,0,0,0,135.865,186.464Z"
          transform="translate(-129.728 -177.186)"
          fill="#777"
        />
      </g>
    </g>
  </svg>
</template>
